import { NumberInput } from '@mantine/core'
import TextInputClasses from '../TextInput/styles.module.css'
import '../../styles/variables.css'

/** Matches TextInput so numeric fields share the same border, radius, and inset shadow. */
export default NumberInput.extend({
    defaultProps: { radius: 'lg', size: 'var(--gm-text-input-height)' },
    classNames: TextInputClasses,
})
